import { RouteObject } from "react-router-dom";
import { ExternalSystemsPage, SignOutHandlerPage, ChangePasswordPage, ProfilePage, VerificationPage } from "../pages";

const userAuthRoutes: RouteObject[] = [
    {
        path: '/',
        element: <ExternalSystemsPage />
    },
    {
        path: 'es/sign-out',
        element: <SignOutHandlerPage />
    },
    {
        path: 'change-password',
        element: <ChangePasswordPage />
    },
    {
        path: 'profile',
        element: <ProfilePage />
    },
    {
        path: 'profile/verification',
        element: <VerificationPage  />
    },
]

export default userAuthRoutes;